import permissions from '@/constants/permissions'

const PaymentCard = () => import('@/views/dashboard/PaymentCard.vue')

export default {
  path: '/karta-wplaty/:paymentId',
  name: 'PaymentCard',
  component: PaymentCard,
  props: (route: { params: { paymentId: string } }) => ({
    paymentId: Number(route.params.paymentId)
  }),
  meta: {
    requireAuth: true,
    permission: permissions.paymentAccess
  }
}
